// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./teachable-tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --loader-background: var(--color-grey-20);
  --loader-color: var(--color-brand-primary-100);
}

#hotmart-cookie_alert-component {
  box-sizing: border-box;
  margin: var(--space-24);
}

/* ALERT */
.cookie-alert-container {
  background: var(--color-white);
  max-width: 540px;
  padding: var(--space-16);
  border-radius: var(--size-8);
  font-family: 'Basis Grotesque', arial, sans-serif;
  box-shadow: -1px 4px 6px rgba(0, 0, 0, 0.25), -1px -1px 10px rgba(0, 0, 0, 0.2);
}

/* header */
.cookie-alert-container-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
}

.cookie-alert-container-title {
  font-family: 'Reckless-Light', aria, sans-serif;
  color: var(--color-grey-100);
  font-weight: var(--font-weight-300);
  font-size: var(--font-size-24);
  line-height: var(--font-size-34);
  margin-top: 0;
  margin-bottom: var(--space-8);
}

.cookie-policy-close {
  display: none;
  border: none;
  background-color: transparent;
  color: var(--color-grey-30);
}

/* body */
.cookie-alert-container-body {
  color: var(--color-grey-100);
  margin-bottom: var(--space-16);
}

.cookie-alert-container-body-text {
  font-feature-settings: 'liga';
  font-weight: var(--font-weight-400);
  font-size: var(--font-size-14);
  line-height: 1.5;
  margin-top: 0;
}

/* footer */
.cookie-policy-footer {
  display: flex;
  justify-content: flex-start;
}

.cookie-policy-button {
  cursor: pointer;
  padding: var(--size-16);
  font-family: 'Basis Grotesque', arial, sans-serif;
  border-style: solid;
  border-radius: var(--size-6);
  border-width: 0;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-500);
  line-height: var(--line-height-150);
  background-color: var(--color-brand-primary-100);
  border-color: var(--color-brand-primary-100);
  color: var(--color-grey-100);
}

.cookie-policy-button.cookie-policy-ok {
  padding: var(--size-16) var(--size-24);
  font-size: var(--font-size-18);
}
.cookie-policy-button:hover {
  background-color: var(--color-brand-primary-80);
  border-color: var(--color-brand-primary-80);
}

a {
  color: var(--color-brand-primary-160);
}
a:hover {
  color: var(--color-brand-primary-120);
}
/* ConfirmModal */

.hotmart-cookie-modal-configuration {
  background-color: var(--color-white);
  font-family: 'Basis Grotesque', arial, sans-serif;
  border-radius: 5px;
  box-shadow: 0 5px 40px rgb(0, 0, 0, 0.16);
}

.modal.hotmart-cookie-modal-configuration {
  padding: 20px;
}

.modal.hotmart-cookie-modal-configuration .cookie-banner-modal-body {
  margin-bottom: 8px;
}

.cookie-banner-modal-title {
  font-family: 'Reckless-Light', aria, sans-serif;
  font-feature-settings: 'liga';
  color: var(--color-grey-100);
  font-weight: var(--font-weight-500);
  font-size: var(--size-20);
  margin-top: 0;
  margin-bottom: 8px;
}

.cookie-banner-modal-body .cookie-banner-categories-item {
  padding: 5px 0;
}

.cookie-banner-modal-description,
.cookie-banner-category-form-label,
.cookie-banner-category-description {
  font-weight: var(--font-weight-400);
  font-size: var(--font-size-16);
  line-height: 1.5;
  margin-top: 0;
  color: var(--color-grey-70);
  margin-bottom: 8px;
}

.cookie-banner-category-form-label {
  font-size: var(--font-size-18);
  color: var(--color-grey-80);
}

.cookie-banner-modal-footer {
  display: flex;
  justify-content: flex-end;
}
.cookie-banner-categories-list {
  margin: 0;
}

.cookie-banner-category-table {
  border-collapse: collapse;
  margin-top: var(--size-8);
  margin-left: var(--size-8);
}

.cookie-banner-category-table th {
  padding: var(--size-8);
  color: var(--color-grey-90);
}

.cookie-banner-category-table td {
  padding: var(--size-8);
  color: var(--color-grey-80);
  vertical-align: top;
}

.cookie-banner-category-table tbody tr:hover {
  background-color: var(--color-brand-primary-20);
}

.hotmart-cookie-modal-configuration input[type='checkbox'] {
  accent-color: var(--color-brand-primary-100);
}

#hotmart-cookie_alert-component .cookie-policy-footer button {
  margin-right: var(--space-16);
}

#hotmart-cookie_alert-component .cookie-policy-footer button:last-of-type {
  margin-right: 0;
}

.cookie-banner-category-table {
  width: 100%;
  border-collapse: collapse;
  margin-left: 0;
}

/* code to hide de description column at TeachableConfirmModal */
.cookie-banner-category-table th:nth-child(3),
.cookie-banner-category-table td:nth-child(3) {
  display: none;
}

@media all and (max-width: 768px) {
  #hotmart-cookie_alert-component {
    margin: var(--space-12);
  }

  #hotmart-cookie_alert-component .cookie-alert-container {
    padding: var(--space-16);
  }

  #hotmart-cookie_alert-component .cookie-policy-footer {
    flex-direction: column;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button {
    width: 100%;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button {
    margin-right: 0;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button:not(.cookie-policy-ok) {
    margin-top: var(--size-12);
  }

  .modal.hotmart-cookie-modal-configuration {
    padding: 15px;
    width: 75%;
    height: 90%;
  }

  .cookie-banner-category-table thead {
    display: none;
  }

  .cookie-banner-category-table tr {
    display: block;
    margin-bottom: 20px;
    border-radius: 5px;
    background-color: #f9f9f9;
  }

  .cookie-banner-category-table td {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid #ddd;
  }

  .cookie-banner-category-table td:last-child {
    border-bottom: none;
  }

  .cookie-banner-category-table td::before {
    content: attr(data-label);
    font-weight: bold;
    flex: 1;
    padding-right: 10px;
  }

  .cookie-banner-category-table td:nth-child(1)::before {
    content: 'Name';
  }
  .cookie-banner-category-table td:nth-child(2)::before {
    content: 'Domain';
  }
  .cookie-banner-category-table td:nth-child(3)::before {
    content: 'Description';
  }
}
`, "",{"version":3,"sources":["webpack://./src/cookie-banner/implementations/teachable/style.css"],"names":[],"mappings":"AAEA;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,iDAAiD;EACjD,+EAA+E;AACjF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,gCAAgC;EAChC,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,gDAAgD;EAChD,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA,iBAAiB;;AAEjB;EACE,oCAAoC;EACpC,iDAAiD;EACjD,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,OAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@import './teachable-tokens.css';\n\n:host {\n  --loader-background: var(--color-grey-20);\n  --loader-color: var(--color-brand-primary-100);\n}\n\n#hotmart-cookie_alert-component {\n  box-sizing: border-box;\n  margin: var(--space-24);\n}\n\n/* ALERT */\n.cookie-alert-container {\n  background: var(--color-white);\n  max-width: 540px;\n  padding: var(--space-16);\n  border-radius: var(--size-8);\n  font-family: 'Basis Grotesque', arial, sans-serif;\n  box-shadow: -1px 4px 6px rgba(0, 0, 0, 0.25), -1px -1px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* header */\n.cookie-alert-container-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.cookie-alert-container-title {\n  font-family: 'Reckless-Light', aria, sans-serif;\n  color: var(--color-grey-100);\n  font-weight: var(--font-weight-300);\n  font-size: var(--font-size-24);\n  line-height: var(--font-size-34);\n  margin-top: 0;\n  margin-bottom: var(--space-8);\n}\n\n.cookie-policy-close {\n  display: none;\n  border: none;\n  background-color: transparent;\n  color: var(--color-grey-30);\n}\n\n/* body */\n.cookie-alert-container-body {\n  color: var(--color-grey-100);\n  margin-bottom: var(--space-16);\n}\n\n.cookie-alert-container-body-text {\n  font-feature-settings: 'liga';\n  font-weight: var(--font-weight-400);\n  font-size: var(--font-size-14);\n  line-height: 1.5;\n  margin-top: 0;\n}\n\n/* footer */\n.cookie-policy-footer {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.cookie-policy-button {\n  cursor: pointer;\n  padding: var(--size-16);\n  font-family: 'Basis Grotesque', arial, sans-serif;\n  border-style: solid;\n  border-radius: var(--size-6);\n  border-width: 0;\n  font-size: var(--font-size-14);\n  font-weight: var(--font-weight-500);\n  line-height: var(--line-height-150);\n  background-color: var(--color-brand-primary-100);\n  border-color: var(--color-brand-primary-100);\n  color: var(--color-grey-100);\n}\n\n.cookie-policy-button.cookie-policy-ok {\n  padding: var(--size-16) var(--size-24);\n  font-size: var(--font-size-18);\n}\n.cookie-policy-button:hover {\n  background-color: var(--color-brand-primary-80);\n  border-color: var(--color-brand-primary-80);\n}\n\na {\n  color: var(--color-brand-primary-160);\n}\na:hover {\n  color: var(--color-brand-primary-120);\n}\n/* ConfirmModal */\n\n.hotmart-cookie-modal-configuration {\n  background-color: var(--color-white);\n  font-family: 'Basis Grotesque', arial, sans-serif;\n  border-radius: 5px;\n  box-shadow: 0 5px 40px rgb(0, 0, 0, 0.16);\n}\n\n.modal.hotmart-cookie-modal-configuration {\n  padding: 20px;\n}\n\n.modal.hotmart-cookie-modal-configuration .cookie-banner-modal-body {\n  margin-bottom: 8px;\n}\n\n.cookie-banner-modal-title {\n  font-family: 'Reckless-Light', aria, sans-serif;\n  font-feature-settings: 'liga';\n  color: var(--color-grey-100);\n  font-weight: var(--font-weight-500);\n  font-size: var(--size-20);\n  margin-top: 0;\n  margin-bottom: 8px;\n}\n\n.cookie-banner-modal-body .cookie-banner-categories-item {\n  padding: 5px 0;\n}\n\n.cookie-banner-modal-description,\n.cookie-banner-category-form-label,\n.cookie-banner-category-description {\n  font-weight: var(--font-weight-400);\n  font-size: var(--font-size-16);\n  line-height: 1.5;\n  margin-top: 0;\n  color: var(--color-grey-70);\n  margin-bottom: 8px;\n}\n\n.cookie-banner-category-form-label {\n  font-size: var(--font-size-18);\n  color: var(--color-grey-80);\n}\n\n.cookie-banner-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n.cookie-banner-categories-list {\n  margin: 0;\n}\n\n.cookie-banner-category-table {\n  border-collapse: collapse;\n  margin-top: var(--size-8);\n  margin-left: var(--size-8);\n}\n\n.cookie-banner-category-table th {\n  padding: var(--size-8);\n  color: var(--color-grey-90);\n}\n\n.cookie-banner-category-table td {\n  padding: var(--size-8);\n  color: var(--color-grey-80);\n  vertical-align: top;\n}\n\n.cookie-banner-category-table tbody tr:hover {\n  background-color: var(--color-brand-primary-20);\n}\n\n.hotmart-cookie-modal-configuration input[type='checkbox'] {\n  accent-color: var(--color-brand-primary-100);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer button {\n  margin-right: var(--space-16);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer button:last-of-type {\n  margin-right: 0;\n}\n\n.cookie-banner-category-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-left: 0;\n}\n\n/* code to hide de description column at TeachableConfirmModal */\n.cookie-banner-category-table th:nth-child(3),\n.cookie-banner-category-table td:nth-child(3) {\n  display: none;\n}\n\n@media all and (max-width: 768px) {\n  #hotmart-cookie_alert-component {\n    margin: var(--space-12);\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container {\n    padding: var(--space-16);\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer {\n    flex-direction: column;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button {\n    width: 100%;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button {\n    margin-right: 0;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button:not(.cookie-policy-ok) {\n    margin-top: var(--size-12);\n  }\n\n  .modal.hotmart-cookie-modal-configuration {\n    padding: 15px;\n    width: 75%;\n    height: 90%;\n  }\n\n  .cookie-banner-category-table thead {\n    display: none;\n  }\n\n  .cookie-banner-category-table tr {\n    display: block;\n    margin-bottom: 20px;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n  }\n\n  .cookie-banner-category-table td {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .cookie-banner-category-table td:last-child {\n    border-bottom: none;\n  }\n\n  .cookie-banner-category-table td::before {\n    content: attr(data-label);\n    font-weight: bold;\n    flex: 1;\n    padding-right: 10px;\n  }\n\n  .cookie-banner-category-table td:nth-child(1)::before {\n    content: 'Name';\n  }\n  .cookie-banner-category-table td:nth-child(2)::before {\n    content: 'Domain';\n  }\n  .cookie-banner-category-table td:nth-child(3)::before {\n    content: 'Description';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
